import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { ChatPane } from '../research/ChatPane';
import { TourProvider } from '../../tours/TourProvider';

export function Layout() {
  const { pathname } = useLocation();
  // Memo tab subroutes (/app/research/:id/{memo|discuss|…}) are one page —
  // collapse them to the job's base path so switching tabs doesn't remount
  // JobDetail (which would refetch the full memo blob) or replay the enter
  // transition. /app/research/new keeps its own key (no third segment).
  const pageKey = pathname.replace(
    /^(\/app\/research\/[^/]+)\/(memo|discuss|quiz|opposing|drafts)$/,
    '$1',
  );
  return (
    <div className="min-h-screen bg-legal-50">
      <Navbar />
      <div className="flex">
        <Sidebar />
        {/* key remounts main on route change → CSS page-enter transition */}
        <main key={pageKey} className="flex-1 min-w-0 p-4 lg:p-8 pb-24 lg:pb-8 animate-page-enter">
          <Outlet />
        </main>
        {/* Global research chat — flex sibling so the desktop dock PUSHES
            content (never an overlay); stays mounted across routes so a
            half-framed question survives navigation. Deliberately NOT keyed
            on the route. */}
        <ChatPane />
      </div>
      <BottomNav />
      {/* Guided tours — auto mini-tours, coach marks, resume snackbar (tour spec §6) */}
      <TourProvider />
    </div>
  );
}
